import React from 'react';
import { useTranslation } from 'react-i18next';
import Shimmer from '../shared/Shimmer';

/**
 * Skeleton card for the Coming Up section — compact trip/activity card shape.
 */
function ComingUpCardSkeleton() {
  return (
    <div className="flex-shrink-0 w-[80vw] max-w-72 bg-surface rounded-xl border border-subtle overflow-hidden animate-pulse snap-start">
      <div className="aspect-[16/9] bg-background" />
      <div className="p-3 space-y-2">
        <Shimmer className="h-4 w-3/4 bg-background rounded-lg" />
        <Shimmer className="h-3 w-1/2 bg-background rounded-lg" />
        <Shimmer className="h-3 w-2/3 bg-background rounded-lg" />
      </div>
    </div>
  );
}

/**
 * Skeleton card for feed sections — matches UnifiedCard aspect ratio.
 */
function FeedCardSkeleton() {
  return (
    <div className="flex-shrink-0 w-[80vw] max-w-72 bg-surface rounded-xl border border-subtle overflow-hidden animate-pulse snap-start">
      <div className="aspect-[4/3] bg-background" />
      <div className="p-3 space-y-2">
        <div className="flex items-center space-x-2">
          <div className="w-6 h-6 rounded-full bg-background" />
          <Shimmer className="h-3 w-20 bg-background rounded-lg" />
        </div>
        <Shimmer className="h-4 w-3/4 bg-background rounded-lg" />
        <Shimmer className="h-3 w-full bg-background rounded-lg" />
        <div className="flex items-center space-x-3 pt-1">
          <Shimmer className="h-3 w-8 bg-background rounded-lg" />
          <Shimmer className="h-3 w-8 bg-background rounded-lg" />
          <Shimmer className="h-3 w-8 bg-background rounded-lg" />
        </div>
      </div>
    </div>
  );
}

/**
 * Renders a row of skeleton cards for a Coming Up section.
 */
function ComingUpSkeleton({ count = 4 }) {
  const { t } = useTranslation('home');
  return (
    <>
      <span className="sr-only" role="status" aria-live="polite">{t('dashboardSkeleton.loadingUpcoming')}</span>
      {Array.from({ length: count }).map((_, i) => (
        <ComingUpCardSkeleton key={i} />
      ))}
    </>
  );
}

/**
 * Renders a row of skeleton cards for a feed section.
 */
function FeedSectionSkeleton({ count = 4 }) {
  const { t } = useTranslation('home');
  return (
    <>
      <span className="sr-only" role="status" aria-live="polite">{t('dashboardSkeleton.loadingFeed')}</span>
      {Array.from({ length: count }).map((_, i) => (
        <FeedCardSkeleton key={i} />
      ))}
    </>
  );
}

export { ComingUpSkeleton, FeedSectionSkeleton, ComingUpCardSkeleton, FeedCardSkeleton };
